import SearchFound from "./SearchFound";
import SupplementCropReplicate from "./SupplementCropReplicate";
import ReportMessage from "./ReportMessage";
import SupplementReportImageEnhancements from "./SupplementReportImageEnhancements";
import SignalLoadingControlPlot from "./SignalLoadingControlPlot";
import DemoQuantifications from "./DemoQuantifications.json";
import WarningIcon from '@material-ui/icons/Warning';
import VerifiedIcon from './VerifiedIcon';
import VerifiedCircleIcon from './VerifiedCircleIcon';
import MolecularWeights from './MolecularWeights';
import { argmin } from './utils'; 

const ERROR_COLOR = 'crimson';
const SUCCESS_COLOR = '#ccc';

const LC_PRESENT = "replicates.lcPres";
const LC_SATURATION = "replicates.lcLinRange";

export const FailSign = (
    <span style={{
      color:ERROR_COLOR,
      fontWeight:'bold',
      fontSize:14,
    }}>
      !
    </span>
)


/*

  Views:
    - reason -> figure -> atns -> replicates
    - report-grid by figure
    - 

  Okay, so in the report, we have:
    - the value
    - classification (success | alert)
*/


const headers = {
  target: { header: 'Target',
    render:{
      valid:(val) => val,
    }
  },

  enoughReplicates: { 
    header: 'n≥3',
    alert:"Insufficient replicates",
    isValid:function(value,replicate,target){
      return value >= 3;
    },
    render:{
      alert:function(value,replicate,target){
        return <span> {""+target.replLen} {FailSign} </span>
      }
    },

    focus:[
      { message:"alert", 
        content:(
          <div>
            <b>Insufficient replicates:</b> should have n ≥ 3.
          </div>
        )
      },
      { crop:"target" },
      { cropList:"replicates" }
    ]
  },
  replId: { 
    header: 'ID',
  },


  [LC_PRESENT]: { 
    header: <SearchFound height={18}/>,
    alert:"Missing loading control",
    isValid:function(value,replicate,target){
      return value;
    },
    focus:function(value,replicate,target){


      let message = !replicate.lcPres ? (
        <ReportMessage type="alert">
          <div>
            <b>No loading control found.</b>
          </div>

        </ReportMessage>
      ) : (
        <ReportMessage type="success">
          <div>
            <b>Loading control found.</b>
          </div>
        </ReportMessage>
      )

      return (
        <div>
          {message}
          <div style={{fontSize:24, textAlign:'center'}}>{replicate.label}</div>
          
          <SupplementCropReplicate
            membrane={replicate.gelId}
            //toHighlight={[imageSetId]}
            expandMembrane={true}
          />

        </div>
      )

    },
  },


  [LC_SATURATION]: { 
    alert:"Oversaturated loading control",
    requires:(state,reportItem) => {
      debugger;
    },
    header: 'Range',

    ignoreSelection:(val,replicate,target) => {
        return !replicate.lcPres
    },

    
    focus:[
      {
        quantifications:[ "control", "target" ]
      },
      {crop:"control"},
      {crop:"target"},
    ],


    focus:function(value,replicate,target){
      return (<SignalLoadingControlPlot {...{
        value,
        replicate,
        target,
        type:"saturation"
      }}/>)
    },

    isValid:function(value,replicate,target){
      return replicate.lcPres && !replicate.saturated;
    },

    render:{
      alert:function(value,replicate,target){
        if( !replicate.lcPres ){
          return NotAllowed;
        }
        return ({[null]:NotAllowed,[true]:null,[false]:FailSign})[value];
      }
    }
  },


  "replicates.lcUniformDist":{ 
    alert:"Protein loaded unevenly",
    header:'Even' ,
    ignoreSelection:(val,replicate,target) => {
        return !replicate.lcPres
    },


    /*focus:[
      {
        quantifications:[ "control", "target" ]
      },
      {crop:"control"},
      {crop:"target"},
    ],*/

    focus:function(value,replicate,target){
      return (<SignalLoadingControlPlot {...{
        value,
        replicate,
        target,
      }}/>)
    },

    isValid:function(value,replicate,target){

      if( !replicate.lcPres ){
        return false;
      }

    },
    render:{
      alert:function(value,replicate,target){

        if( !replicate.lcPres ){
          return NotAllowed;
        }else{
          let quantFind = DemoQuantifications.find(x => x.annotationId === replicate.control);


          let isEven =  quantFind?.even;

          return isEven ? SuccessSign : FailSign;

        }
      }
    },

    val:(function(val,replicateObj,targetObj){
      
    })

  },
  //mwPres: { header: 'Found' },


  "replicates.mwMatch": { 
    alert:"Molecular weight unexpected",
    header: <div style={{fontSize:20}}>≈</div>,
    focus:[
      {
        membrane:"annotationId",
        overlay:"molecularWeightExpectation"
      }
    ],
  },


  "replicates.imageEnhancements":{ 
    alert:"Image enhancements",
    header:<VerifiedCircleIcon height={"16px"}/>,
    val:val => (val?WarningSign:SuccessSign),

    focus:function(value,replicate,target){
      return (<SupplementReportImageEnhancements {...{
        value,
        replicate,
        target,
      }}/>)
    },

  }
}

let WarningSign = <WarningIcon style={{color:'orange'}}/>


//✗
export const NotAllowed = (
  <div style={{
      color:SUCCESS_COLOR,
      fontWeight:'bold',
      fontSize:14,
    }} class="absolute-cover sg-row v-center h-center">
    ⦸
    </div>

)
export const SuccessSign = (
    <div style={{
      color:SUCCESS_COLOR,
      fontWeight:'bold',
      fontSize:14,
    }} class="absolute-cover sg-row v-center h-center">
     ✓
    </div>
)

export default headers;
